import type { ReactNode } from 'react';

import { Box, CircularProgress } from '@material-ui/core';

import { SimpleAutocomplete } from '../SimpleAutocomplete';
import { useStyles } from './styles';
import type { GroupedAutocompleteItem } from './types';

type GroupedAutocompleteListProps = {
  loading?: boolean;
  emptyMessage: string;
  hasSourceItems: boolean;
  onEndReached?: () => void;
  renderItem: (item: GroupedAutocompleteItem, index: number) => ReactNode;
};

export const GroupedAutocompleteList = ({
  loading,
  emptyMessage,
  hasSourceItems,
  onEndReached,
  renderItem,
}: GroupedAutocompleteListProps) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Box className={classes.list}>
        <Box className={classes.centered}>
          <CircularProgress size={20} />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <SimpleAutocomplete.Empty>
        {hasSourceItems ? 'No matches' : emptyMessage}
      </SimpleAutocomplete.Empty>
      <SimpleAutocomplete.VirtualizedList
        className={classes.list}
        onEndReached={onEndReached}
        renderItem={renderItem}
      />
    </>
  );
};
